<template>
    <div class="header-apr">
      <b-tabs v-model="tabIndex">
           <b-tab :title="'Autorizações'" justified>
            <template slot="title">
              <div style="width:12rem; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-book text-third"></i><span class="d-md-down-none pl-1 text-third"> Detalhes</span>
              </div>
            </template>
            <Details v-if="tabIndex === 0" ref="DetailsApr" :propApr="propApr" @edit="edit"></Details>
           </b-tab>
           <b-tab :title="'Autorizações'">
            <template slot="title" >
              <div style="width:12rem; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-tv" style="color:#008148"></i><span class="d-md-down-none pl-1 text-third"> Mídias</span>
              </div>
            </template>
            <Medias  v-if="tabIndex === 1" ref="midias" :propApr="propApr"></Medias>
           </b-tab>
           <b-tab :title="'Autorizações'">
            <template slot="title">
              <div style="width:12rem; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-signature" style="color:#008148"></i><span class="d-md-down-none pl-1 text-third">Assinaturas</span>
              </div>
            </template>
            <Signature v-if="tabIndex === 2" ref="signatureApr" :propApr="propApr"></Signature>
           </b-tab>
      </b-tabs>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import collapseApr from '@/views/private/apr/registerApr/components/collapseapr/collapseApr.vue'

import Details from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/details/details.vue'
import Medias from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/medias/medias.vue'
import Signature from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/signatures/signatures.vue'

export default {
  name: 'registerTable',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, collapseApr, Medias, Signature, Details},
  data () {
    return {
      colunas: ['CÓDIGO DA APR', 'ÁREA', 'STATUS', 'RESPONSÁVEL', 'DATA APR', 'DATA VENCIMENTO', ''],
      dataTeste: [],
      formSearch: {},
      form: {
        categoria: null,
        descricao: null
      },
      tabIndex: 0,
      localApr: {}
    }
  },

  props: ['propApr'],

  watch: {
  },

  mounted () {
  },
  methods: {
    edit (data) {
      this.$emit('editDetails', data)
    }
  }
}

</script>

<style scoped>
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price{
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
}
.header-title{
color: white;
font-weight: bold;
font-size: 16px;
font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
margin-top: 10;
font-size: 12PX;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #b60000;
color: white;
}
.button-save{
background-color: darkgreen;
color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/inqueryDetailsTableApr.vue